// Per-language SEO metadata for Hotel La Rosa Negra
// Covers organic search + AEO/GEO (AI answer engines) for all 7 supported locales.
// Keywords specifically target: Ulcinj, Velika Plaža (Long Beach), Montenegro, Adriatic,
// family beachfront hotel, sea view balcony, plus city & beach terms in each local language.

export const seo = {
  en: {
    lang: "en",
    ogLocale: "en_US",
    title: "Hotel in Ulcinj, 2 min from Velika Plaža | La Rosa Negra",
    description:
      "Family-run 3-star hotel 2 minutes from Velika Plaža (Long Beach) in Ulcinj, Montenegro. Simple rooms, many with sea-view balcony. Rate includes half board (breakfast + dinner), pool & garage parking. Direct price 10% below Booking.com. Rated 'Good' by 750+ guests on Booking.com.",
    keywords: [
      "Hotel La Rosa Negra",
      "hotel Ulcinj",
      "hotel in Ulcinj Montenegro",
      "Velika Plaza hotel",
      "Long Beach Ulcinj hotel",
      "beachfront hotel Montenegro",
      "sea view hotel Ulcinj",
      "family hotel Ulcinj",
      "Adriatic coast hotel",
      "Ulcinj accommodation",
      "Ulcinj Long Beach",
      "Montenegro beach vacation",
      "hotel Port Milena",
      "pool hotel Ulcinj",
      "3 star hotel Ulcinj",
      "book direct Ulcinj hotel",
    ].join(", "),
  },
  me: {
    lang: "me",
    ogLocale: "sr_ME",
    title: "Hotel Ulcinj, 2 min od Velike plaže | La Rosa Negra",
    description:
      "Porodični hotel sa 3 zvjezdice direktno na Velikoj plaži u Ulcinju. Sobe s pogledom na more i balkonom. Cijena sobe uključuje polupansion (doručak + večera), besplatan bazen i besplatan parking. Rezervišite direktno i ostvarite najbolju cijenu na Jadranskoj obali.",
    keywords: [
      "Hotel La Rosa Negra",
      "hotel Ulcinj",
      "Velika plaža Ulcinj",
      "hotel Velika plaža",
      "hotel na plaži Ulcinj",
      "porodični hotel Ulcinj",
      "hotel s pogledom na more",
      "jeftini hotel Ulcinj",
      "smještaj Ulcinj",
      "letovanje Ulcinj",
      "Jadranska obala",
      "Crna Gora more",
      "hotel pored mora Ulcinj",
      "Port Milena Ulcinj",
      "rezervacija hotel Ulcinj",
    ].join(", "),
  },
  sq: {
    lang: "sq",
    ogLocale: "sq_AL",
    title: "Hotel në Ulqin, 2 min nga Plazhi i Madh | La Rosa Negra",
    description:
      "Hotel familjar 3 yje në Plazhin e Madh (Velika Plazha) në Ulqin, Mali i Zi. Dhoma me pamje nga deti dhe ballkon. Çmimi i dhomës përfshin gjysmë-bord (mëngjes + darkë), pishinë falas dhe parking falas. Rezervoni direkt për çmimin më të mirë në bregdetin e Adriatikut.",
    keywords: [
      "Hotel La Rosa Negra",
      "hotel Ulqin",
      "hotel ne Ulqin",
      "Plazhi i Madh Ulqin",
      "Velika Plazha Ulqin",
      "hotel ne plazh Ulqin",
      "hotel me pamje deti Ulqin",
      "hotel familjar Ulqin",
      "Ulqin akomodim",
      "pushime Ulqin",
      "bregdeti Adriatikut",
      "Mali i Zi deti",
      "Port Milena",
      "hotele Ulqin",
    ].join(", "),
  },
  de: {
    lang: "de",
    ogLocale: "de_DE",
    title: "Hotel Ulcinj, 2 Min. zum Strand Velika Plaža | La Rosa Negra",
    description:
      "Familienfreundliches 3-Sterne-Hotel direkt am Velika Plaža (langer Sandstrand) in Ulcinj, Montenegro. Zimmer mit Meerblick-Balkon. Zimmerpreis inkl. Halbpension (Frühstück + Abendessen), kostenfreier Pool und kostenfreies Parken. Direkt buchen und Bestpreis an der Adriaküste sichern.",
    keywords: [
      "Hotel La Rosa Negra",
      "Hotel Ulcinj",
      "Hotel Montenegro Ulcinj",
      "Strandhotel Ulcinj",
      "Hotel Velika Plaza",
      "Hotel am Langen Strand",
      "Familienhotel Montenegro",
      "Hotel Meerblick Ulcinj",
      "Ulcinj Unterkunft",
      "Montenegro Strandurlaub",
      "Adriaküste Hotel",
      "günstiges Hotel Ulcinj",
      "Hotel mit Pool Ulcinj",
    ].join(", "),
  },
  ru: {
    lang: "ru",
    ogLocale: "ru_RU",
    title: "Отель в Улцине, 2 мин. до Велика Плажа | La Rosa Negra",
    description:
      "Семейный 3-звёздочный отель прямо на Великой пляже (Velika Plaža) в Улцине, Черногория. Номера с видом на море и балконом. В стоимость номера включено: полупансион (завтрак + ужин), бесплатный бассейн и бесплатная парковка. Бронируйте напрямую — лучшая цена на Адриатике.",
    keywords: [
      "отель La Rosa Negra",
      "отель Улцинь",
      "отель в Улцине Черногория",
      "Великая пляжа Улцинь",
      "Велика Плажа",
      "пляжный отель Черногория",
      "отель на море Улцинь",
      "семейный отель Черногория",
      "отдых в Улцине",
      "Адриатическое море",
      "Черногория отдых на море",
      "Port Milena",
    ].join(", "),
  },
  pl: {
    lang: "pl",
    ogLocale: "pl_PL",
    title: "Hotel Ulcinj, 2 min od plaży Velika Plaža | La Rosa Negra",
    description:
      "Rodzinny 3-gwiazdkowy hotel bezpośrednio przy Velika Plaža (Długiej Plaży) w Ulcinju, Czarnogóra. Pokoje z widokiem na morze i balkonem, basen, restauracja, bezpłatne Wi-Fi i parking, transfer z lotniska. Zarezerwuj bezpośrednio i zyskaj najlepszą cenę na Adriatyku.",
    keywords: [
      "Hotel La Rosa Negra",
      "hotel Ulcinj",
      "hotel w Ulcinju Czarnogóra",
      "Velika Plaza hotel",
      "hotel na plaży Ulcinj",
      "hotel rodzinny Czarnogóra",
      "hotel z widokiem na morze Ulcinj",
      "Adriatyk hotel",
      "wakacje Czarnogóra nad morzem",
      "Ulcinj nocleg",
      "hotel z basenem Ulcinj",
    ].join(", "),
  },
  hu: {
    lang: "hu",
    ogLocale: "hu_HU",
    title: "Hotel Ulcinj, 2 percre a Velika Plaža strandtól | La Rosa Negra",
    description:
      "Családbarát 3 csillagos tengerparti hotel közvetlenül a Velika Plaža (Hosszú strand) homokpartján, Ulcinjban, Montenegróban. Tengerre néző erkélyes szobák. A szoba ára tartalmazza a félpanziót (reggeli + vacsora), ingyenes medencehasználatot és ingyenes parkolást. Foglaljon közvetlenül a legjobb áron az Adriai-tengerparton.",
    keywords: [
      "La Rosa Negra Hotel",
      "hotel Ulcinj",
      "szállás Ulcinj",
      "Velika Plaza hotel",
      "tengerparti hotel Montenegró",
      "családi hotel Montenegró",
      "Adria hotel",
      "tengerre néző szoba Ulcinj",
      "Ulcinj nyaralás",
      "montenegrói tengerpart",
      "Hosszú strand Ulcinj",
    ].join(", "),
  },
};

export const getSEO = (lang) => seo[lang] || seo.en;

// Room page <title> / meta description in the visitor's language ({name} {size} {guests} {amenities} {price}).
const ROOM_META = {
  en: { title: "{name} — Hotel La Rosa Negra, Ulcinj", description: "{name} on Velika Plaža, Ulcinj: {size} m², up to {guests} guests, {amenities}. Half board, from €{price}/night — best price direct." },
  me: { title: "{name} — Hotel La Rosa Negra, Ulcinj", description: "{name} na Velikoj plaži, Ulcinj: {size} m², do {guests} gosta, {amenities}. Polupansion, od €{price}/noć — najbolja cijena direktno." },
  sq: { title: "{name} — Hotel La Rosa Negra, Ulqin", description: "{name} në Plazhin e Madh, Ulqin: {size} m², deri në {guests} mysafirë, {amenities}. Gjysmë pension, nga €{price}/natë — çmimi më i mirë direkt." },
  de: { title: "{name} — Hotel La Rosa Negra, Ulcinj", description: "{name} an der Velika Plaža, Ulcinj: {size} m², bis {guests} Gäste, {amenities}. Halbpension, ab €{price}/Nacht — Bestpreis direkt." },
  ru: { title: "{name} — отель La Rosa Negra, Улцинь", description: "{name} на пляже Велика Плажа, Улцинь: {size} м², до {guests} гостей, {amenities}. Полупансион, от €{price}/ночь — лучшая цена напрямую." },
  pl: { title: "{name} — Hotel La Rosa Negra, Ulcinj", description: "{name} przy plaży Velika Plaža, Ulcinj: {size} m², do {guests} gości, {amenities}. Śniadania i kolacje, od €{price}/noc — najlepsza cena bezpośrednio." },
  hu: { title: "{name} — Hotel La Rosa Negra, Ulcinj", description: "{name} a Velika Plažán, Ulcinj: {size} m², max. {guests} fő, {amenities}. Félpanzió, €{price}/éj-től — legjobb ár közvetlenül." },
};

export const getRoomMeta = (lang, room) => {
  const m = ROOM_META[lang] || ROOM_META.en;
  const vars = { name: room.name, size: room.size, guests: room.guests, price: room.price, amenities: (room.amenities || []).slice(0, 2).join(', ') };
  const fill = (s) => s.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? ''));
  return { title: fill(m.title), description: fill(m.description) };
};
